// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDrhlnh8II37eSB05y_QBZujIRDGsa75jg",
  authDomain: "wanjiru-and-anthony-wedding.firebaseapp.com",
  projectId: "wanjiru-and-anthony-wedding",
  storageBucket: "wanjiru-and-anthony-wedding.appspot.com",
  messagingSenderId: "952079580595",
  appId: "1:952079580595:web:e0d1f9cf122f0de1d35fc6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { app, db }